import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClientService } from './http-client.service'
import { switchMap } from 'rxjs/operators'
import { CacheService } from './cache.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpClient } from '@angular/common/http';

const baseUrl = environment.hostService + '/Personal';
const UrlOrg = environment.hostService + '/DatosOrganizativos';
const endPointDirecciones = environment.hostService + '/DireccionesPersonal';

@Injectable({
  providedIn: 'root'
})

export class PersonalService {

  constructor(private _http: HttpClientService,
              private snackBar: MatSnackBar,
              private _cacheService: CacheService,
              private http: HttpClient) { }

  getIndex(): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  getAll(): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetEmployeeList' })
  }

  getDetail(code): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetEmployee/' + code, cacheMins: 0 })
  }

  getById(code): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/Index?id=' + code })
  }

  getListFiltros(legajo, sociedad, sede, subsede, grupoLiq, soloVigentes): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetListFilt?legajo=' + legajo
                                              + '&sociedad=' + sociedad
                                              + '&sede=' + sede
                                              + '&subsede=' + subsede
                                              + '&grupoLiq=' + grupoLiq
                                              + '&solovigentes=' + soloVigentes})
  }

  getListByName(name): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetListByName?nombre=' + name })
  }

  getDatosOrganizativos(code, id): Observable<any> {
    return this._http.get<any>({ url: UrlOrg + '/GetDatosOrganizativosByPersonalId/' + code + '/' + id, cacheMins: 0 })
  }

  getContrator(code): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetContratosByPersonalId/' + code, cacheMins: 0 })
  }

  updateDatosOrganizativos(data): Observable<any> {
    return this._http.post<any>({ url: UrlOrg + '/UpdateDatosOrganizativos', body: data, cacheMins: 0 }).pipe(
      switchMap(response => {
          console.log("--> response code:" +response.code);
          let respMessages = "";
          response.messages.forEach(message => {
            respMessages += (message + '\n');
            });    
            
          alert(respMessages);
          return of<any>(response);
      })
  )
  }

  UpdateProfileImage(data): Observable<any> {
    return this._http.post<any>({ url: baseUrl + '/UpdateProfileImage', body: data, cacheMins: 0 })
  }

  SavePersonal(data): Observable<any> {
    return this._http.post<any>({ url: baseUrl + '/Save', body: data });
  }

  SaveDatosPersonales(data): Observable<any> {
    return this._http.post<any>({ url: baseUrl + '/SaveDatosPersonales', body: data });
  }

  SaveDatosEstadoNomina(data): Observable<any> {
    return this._http.post<any>({ url: baseUrl + '/SaveDatosEstadoNomina', body: data });
  }

  newEmployee(): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/NewEmployee' }).pipe(
      switchMap(response =>
      {
        return of<any>(response.data);
      }));
  } 

  BorrarDatosPersonales(id): Observable<any>
  {
    return this.http.get(baseUrl + '/Delete?id=' + id)
  }

  ChequeoRetroactividad(personal, tabla, desde, hasta, informativo): Observable<any>
  {
    return this.http.get(baseUrl + '/ChequeoRetroactividad?idPersonal=' + personal + '&tabla=' + tabla + '&desde=' + desde + '&hasta=' + hasta + '&informativo=' + informativo)
  }

  getFormatoImportacionEstado() {
    const formato = [
      { personal: 0,
        liquidarDesde: '00/00/0000',
        liquidarHasta: '00/00/0000',
        ultimaLiquidacion: '',
        retroactividad: '',
        bloqueado: 'true/false',
        errores: ['No Completar']}
    ];

    return formato;
  }
}
